import React, { useEffect, useState } from 'react';
import AudioLevelIndicator from '../../../audio-level-indicator/components/AudioLevelIndicator';
import VietMeetJS from '../../../base/vietmeet-lib/_';
const VietMeetTrackEvents = VietMeetJS.events.track;
const ThumbnailAudioIndicator = ({ _audioTrack }) => {
    const [audioLevel, setAudioLevel] = useState(0);
    useEffect(() => {
        setAudioLevel(0);
        if (_audioTrack) {
            const { vietmeetTrack } = _audioTrack;
            vietmeetTrack?.on(VietMeetTrackEvents.TRACK_AUDIO_LEVEL_CHANGED, setAudioLevel);
        }
        return () => {
            if (_audioTrack) {
                const { vietmeetTrack } = _audioTrack;
                vietmeetTrack?.off(VietMeetTrackEvents.TRACK_AUDIO_LEVEL_CHANGED, setAudioLevel);
            }
        };
    }, [_audioTrack]);
    return (React.createElement("span", { className: 'audioindicator-container' },
        React.createElement(AudioLevelIndicator, { audioLevel: audioLevel })));
};
export default ThumbnailAudioIndicator;
